module.exports = __webpack_public_path__ + "static/freetaxprepla-a8ae4dd025839ce113b21cad78b370bb.png";